import React, { useEffect } from 'react'
import ModifyBlock from '../ModifyBlock'
import Typography from '../../Typography'
import theme from '../../../../theme'
import { useSelector } from 'react-redux'
import { StoreState } from '../../../../../store/reducer-main'
import CreditCard from '../../CreditCard.tsx'

interface Props{
  onPaymentMehodModifyPress:()=>void,
  isModifyPaymentMehodPress:boolean
}

export default function PaymentMethodSection({onPaymentMehodModifyPress,isModifyPaymentMehodPress}:Props) {

  const { paymentMethod } = useSelector((state: StoreState) => state.profile);

  useEffect(()=>{
    // console.log("paymentMethod",paymentMethod)
  })

  return (
    <div className='flex justify-between items-center my-5'>
    <div>
      <div  className='flex items-center mb-2'>
      <Typography variant='display'>
        METODO DI PAGAMENTO
      </Typography>
      <ModifyBlock isModifyPaymentMehodPress={isModifyPaymentMehodPress} isAdding={!paymentMethod} onClick={onPaymentMehodModifyPress} style={{marginLeft:theme.sizing.x1}} modifyItem='Metodo di Pagamento'/>
      </div>
      { 
        paymentMethod &&
        <CreditCard cardType={paymentMethod?.card.brand??""} expirationMonth={paymentMethod?.card.exp_month??0} expirationYear={paymentMethod?.card.exp_year??0} lastFourNumbers={paymentMethod?.card.last4??""} style={{marginTop:theme.sizing.x2}}/>
      }
    </div>
 </div>
  )
}
